import rpc, { type $RpcParameters } from '@square/web-rpc-client';
import { ConsoleLoggerFactory } from '@square/web-rpc-client/utils';
import { getDefaultRequestHeaders } from '@squareup/util-api-client';
import { DashboardQueryContext } from '../context';

export default function rpcImpl(args?: $RpcParameters) {
  const { baseUrl, loggingEnabled } = DashboardQueryContext;
  const { additionalHeaders: passedHeaders, urlForMethod: passedUrlForMethod, ...restArgs } = args || {};

  const additionalHeaders = () => {
    const headerMap = getDefaultRequestHeaders();
    if (passedHeaders) {
      const passedHeaderMap =
        passedHeaders instanceof Map ? passedHeaders : passedHeaders();

      passedHeaderMap.forEach((value, key) => {
        headerMap.set(key, value);
      });
    }

    return headerMap;
  };

  const urlForMethod = (derivedUrl: string, service: string, method: string): string => {
    const relativeUrl = passedUrlForMethod ? passedUrlForMethod(derivedUrl, service, method) : derivedUrl;
    return baseUrl ? `${baseUrl}${relativeUrl}` : relativeUrl;
  };

  return rpc({
    loggerFactory: new ConsoleLoggerFactory(loggingEnabled),
    additionalHeaders,
    urlForMethod,
    ...restArgs,
  });
}
